import {
  roseColor,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor
} from 'styles/jss/nextjs-material-kit-pro.js';

const navPillsStyle = (theme) => ({
  root: {
    marginTop: '20px',
    paddingLeft: '0',
    marginBottom: '0',
    overflow: 'visible !important'
  },
  rootShopping: {
    marginTop: '20px',
    paddingLeft: '0',
    marginBottom: '0',
    '@media (max-width: 640px)': {
      position: 'relative',
      width: '100%',
      height: '100%',
      overflowY: 'hidden',
      overflowX: 'scroll',
      whiteSpace: 'nowrap',
      boxSizing: 'content-box',
      display: 'inline-block',
      minHeight: '60px'
    }
  },
  flexContainer: {
    '@media (max-width: 640px)': {
      display: 'flex',
      flexWrap: 'nowrap'
    }
  },
  flexContainerShopping: {
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexWrap: 'wrap'
    }
  },
  displayNone: {
    display: 'none !important'
  },
  fixed: {
    overflow: 'visible !important'
  },
  fixedShopping: {
    overflow: 'visible !important',
    '@media (max-width: 640px)': {
      paddingBottom: '5px'
    }
  },
  horizontalDisplay: {
    display: 'block'
  },
  pills: {
    float: 'left',
    position: 'relative',
    display: 'block',
    borderRadius: '30px',
    minWidth: '100px',
    textAlign: 'center',
    transition: 'all .3s',
    padding: '10px 15px',
    color: grayColor[15],
    height: 'auto',
    opacity: '1',
    maxWidth: '100%',
    margin: '0 5px',
    minHeight: 'unset',
    lineHeight: '24px',
    textTransform: 'uppercase',
    fontSize: '12px',
    fontWeight: '500',
    '@media (max-width: 640px)': {
      minWidth: '80px'
    }
  },
  pillsWithIcons: {
    borderRadius: '4px'
  },
  tabIcon: {
    width: '30px',
    height: '30px',
    display: 'block',
    margin: '15px 0 !important'
  },
  horizontalPills: {
    width: '100%',
    float: 'none !important',
    '& + button': {
      margin: '10px 0'
    }
  },
  contentWrapper: {
    marginTop: '20px',
    '& .react-swipeable-view-container > div > div': {
      paddingLeft: '15px',
      paddingRight: '15px',
      '@media (max-width: 640px)': {
        paddingLeft: '0',
        paddingRight: '0'
      }
    }
  },
  primary: {
    '&,&:hover': {
      color: whiteColor,
      backgroundColor: primaryColor[0]
    }
  },
  info: {
    '&,&:hover': {
      color: whiteColor,
      backgroundColor: infoColor[0]
    }
  },
  success: {
    '&,&:hover': {
      color: whiteColor,
      backgroundColor: successColor[0]
    }
  },
  warning: {
    '&,&:hover': {
      color: whiteColor,
      backgroundColor: warningColor[0]
    }
  },
  danger: {
    '&,&:hover': {
      color: whiteColor,
      backgroundColor: dangerColor[0]
    }
  },
  rose: {
    '&,&:hover': {
      color: whiteColor,
      backgroundColor: roseColor[0]
    }
  },
  alignCenter: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  tabLabelContainer: {
    padding: 'unset !important'
  }
});

export default navPillsStyle;
